import React from 'react';
import { Box } from '../../../../../../../packages/ds/src/components/box';
import { Button } from '../../../../../../../packages/ds/src/components/button';
import { Typography } from '../../../../../../../packages/ds/src/components/typography';
import { MOBILE_BREAKPOINT_THRESHOLD, SxProps } from '../../../../../../../packages/ds';
import { styled } from '../../../../../../../packages/ds/src/theme/styled';
import { StepFooter } from '../stepFooter';
import one from '../assets/welcome-1x3.png';
import two from '../assets/welcome-2x3.png';
import three from '../assets/welcome-3x3.png';
import line1 from '../assets/ld-1.svg?url';
import line2 from '../assets/ld-2.svg?url';
import line1Mobile from '../assets/lm-1.svg?url';
import line2Mobile from '../assets/lm-2.svg?url';
import { StepProps } from './model';

const StyledT = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    gap: theme.spacing(2),
    alignItems: 'center',
    flexDirection: 'row',
  },
}));

const Text = ({ number, children, sx }: { number: number; children: React.ReactNode; sx?: SxProps }) => (
  <StyledT component="li" sx={sx}>
    <Typography component="span" variant="h0">
      {number}
    </Typography>
    <Typography variant="h3">{children}</Typography>
  </StyledT>
);

const StyledBox = styled(Box)(({ theme }) => ({
  width: '350px',
  margin: '0 auto',
  position: 'relative',
  display: 'flex',
  flexGrow: 1,
  flexDirection: 'column',
  justifyContent: 'space-between',
  background: [
    `url(${one}) 100% 0/154px no-repeat`,
    `url(${two}) 0 220px/154px no-repeat`,
    `url(${three}) 100% 400px/154px no-repeat`,
    `url(${line1Mobile}) 90px 125px no-repeat`,
    `url(${line2Mobile}) 64px 363px no-repeat`,
  ].join(', '),
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    width: '695px',
    height: '494px',
    background: [
      `url(${one}) 0 0/200px no-repeat`,
      `url(${two}) 100% 110px/200px no-repeat`,
      `url(${three}) 0 300px/200px no-repeat`,
      `url(${line1}) 187px 96px no-repeat`,
      `url(${line2}) 162px 248px no-repeat`,
    ].join(', '),
  },
}));
const StyledList = styled(Box)(({ theme }) => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '80px',
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    padding: '20px 200px 0',
    gap: '100px',
  },
}));

export const StepWelcome: React.FC<StepProps> = ({ onSubmit }) => {
  return (
    <>
      <StyledBox>
        <StyledList component="ol" sx={{}}>
          <Text number={1} sx={{ paddingRight: { xs: '154px', [MOBILE_BREAKPOINT_THRESHOLD]: 0 } }}>
            Посмотрите обучающие видео
            <Typography component="div">~15 минут</Typography>
          </Text>
          <Text number={2} sx={{ paddingLeft: { xs: '154px', [MOBILE_BREAKPOINT_THRESHOLD]: 0 } }}>
            Пройдите все тесты правильно
            <Typography component="div">~5 минут</Typography>
          </Text>
          <Text number={3} sx={{ pr: { xs: '154px', [MOBILE_BREAKPOINT_THRESHOLD]: 0 } }}>
            Всего 3 блока и вы можете получать заказы!
          </Text>
        </StyledList>
      </StyledBox>
      <StepFooter>
        <Button
          onClick={() => onSubmit()}
          sx={{
            width: { xs: 1, [MOBILE_BREAKPOINT_THRESHOLD]: 'auto' },
          }}
        >
          Давайте начнем!
        </Button>
      </StepFooter>
    </>
  );
};
